import React from "react";
import UniversityCard from "./UniversityCard";
import { getUniversityCategory } from "../utils/getUniversityCategory"; // Import categorization function
import "../styles/UniversityList.css";
import { useAuth } from "../context/AuthContext";
import SEO from "./SEO";

const UniversityList = ({ universities = [] }) => {
  const { isLoggedIn } = useAuth();
  return (
    <div className="university-list">
      <SEO
        title="Top Universities Worldwide - Compare & Choose | Grad4Grad"
        description="Explore and compare top universities worldwide. Find detailed information about tuition fees, admission requirements, and programs for international students. Make informed decisions about your study abroad journey."
        keywords="top universities, university comparison, international universities, university rankings, study abroad universities, university admission requirements, tuition fees comparison"
        image="https://grad4grad.com/logo512.png"
        url="https://grad4grad.com/universities"
        type="website"
      />
      {universities.length > 0 ? (
        universities.map((university, index) => {
          const category = getUniversityCategory(university.tuitionFees);
          return (
            <div className="university-item" key={index}>
              {/* Pass category and isLoggedIn as props */}
              <UniversityCard
                university={university}
                category={category}
                isLoggedIn={isLoggedIn}
              />
            </div>
          );
        })
      ) : (
        <p>No universities to display.</p>
      )}
    </div>
  );
};

export default UniversityList;
